import { render, staticRenderFns } from "./AddOrderPrice.vue?vue&type=template&id=7b5f0092&scoped=true"
import script from "./AddOrderPrice.vue?vue&type=script&lang=js"
export * from "./AddOrderPrice.vue?vue&type=script&lang=js"
import style0 from "./AddOrderPrice.vue?vue&type=style&index=0&id=7b5f0092&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b5f0092",
  null
  
)

export default component.exports